import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import '@/App.css';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import Tickets from './pages/Tickets';
import Logs1 from './pages/Logs1';
import AuthLogs from './pages/authlogs';
import Users from './pages/Users';
import Reports from './pages/Reports';
import DeveloperPerformance from './pages/DeveloperPerformance';
import Timesheet from './pages/Timesheet';
import { Toaster } from './components/ui/sonner';
// Auth
import { auth } from "@/firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import InspectBlocked from './InspectBlocked';
import Loader from './components/Loader';
import AnalyticsTracker from './components/AnalyticsTracker';
import Ideas from './pages/Ideas';
import { AuthProvider } from './AuthContext/AuthContext';
import Clarity from '@microsoft/clarity';
export default function Wrapper() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  );
}

// Custom hook for Auth
export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });

    return () => unsub();
  }, []);

  const logout = () => signOut(auth);

  return { user, loading, logout };
};

// function ProtectedRoute({ children }) {
//   const { user, loading } = useAuth();

//   if (loading) return <Loader />;
//   if (!user) return <Navigate to="/login" replace />;

//   return children;
// }

function ProtectedRoute({ children }) {
  const { loading } = useAuth();

  if (loading) return <Loader />;

  // 🔥 DIRECT Firebase check (no race condition)
  if (!auth.currentUser) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function App() {
  const navigate = useNavigate();
  const projectId = process.env.CLARITY_PROJECT_ID;

  Clarity.init(projectId);
  // Clarity.start();
  // Clarity.enableHeatmaps();
  // Clarity.enableSessionRecording();
  // Clarity.enableFormAnalytics();
  // Clarity.enableRageClicks();
  // Clarity.enableErrorTracking();
  // Clarity.enableCustomTags();
  // Clarity.enableUserIdentification();

  useEffect(() => {
    const SESSION_TIME = 30 * 60 * 1000; // 30 min

    const interval = setInterval(async () => {
      const user = auth.currentUser;
      const loginTime = localStorage.getItem("loginTime");

      // 🔥 User exists but no loginTime → INVALID session
      if (user && !loginTime) {
        await signOut(auth);
        navigate("/login");
        return;
      }

      if (!loginTime) return;

      if (Date.now() - Number(loginTime) > SESSION_TIME) {
        await signOut(auth);
        localStorage.removeItem("loginTime");
        navigate("/login");
      }
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, [navigate]);

  // ============================
  //  Detect DevTools globally
  // ============================
  // useEffect(() => {
  //   // Disable right-click
  //   const disableRC = (e) => e.preventDefault();
  //   document.addEventListener("contextmenu", disableRC);

  //   // Disable DevTools keyboard shortcuts
  //   const keyBlocker = (e) => {
  //     if (
  //       // e.key === "F12" ||
  //       (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key)) ||
  //       (e.ctrlKey && e.key === "U")
  //     ) {
  //       e.preventDefault();
  //     }
  //   };
  //   document.addEventListener("keydown", keyBlocker);

  //   // SAFE DevTools Detector (No debugger)
  //   let lastCheck = 0;
  //   const checkDevTools = () => {
  //     const threshold = 150;

  //     const widthDiff = window.outerWidth - window.innerWidth;
  //     const heightDiff = window.outerHeight - window.innerHeight;

  //     const devtoolsOpened = widthDiff > threshold || heightDiff > threshold;

  //     if (devtoolsOpened) {
  //       navigate("/no-inspect");
  //     }

  //     lastCheck = requestAnimationFrame(checkDevTools);
  //   };

  //   lastCheck = requestAnimationFrame(checkDevTools);

  //   return () => {
  //     cancelAnimationFrame(lastCheck);
  //     document.removeEventListener("contextmenu", disableRC);
  //     document.removeEventListener("keydown", keyBlocker);
  //   };
  // }, [navigate]);




  return (
    <>
      <AnalyticsTracker />
      <Routes>
        <Route path="/no-inspect" element={<InspectBlocked />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/projects"
          element={
            <ProtectedRoute>
              <Projects />
            </ProtectedRoute>
          }
        />
        <Route
          path="/logs1"
          element={
            <ProtectedRoute>
              <Logs1 />
            </ProtectedRoute>
          }
        />
        {/* AuthLogs */}
        <Route
          path="/auth-logs"
          element={
            <ProtectedRoute>
              <AuthLogs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tickets"
          element={
            <ProtectedRoute>
              <Tickets />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <Reports />
            </ProtectedRoute>
          }
        />
        <Route
          path="/performance"
          element={
            <ProtectedRoute>
              <DeveloperPerformance />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ideas"
          element={
            <ProtectedRoute>
              <Ideas />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <Users />
            </ProtectedRoute>
          }
        />

        <Route
          path="/timesheet"
          element={
            <ProtectedRoute>
              <Timesheet />
            </ProtectedRoute>
          }
        />

        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>

      <Toaster position="top-right" />
    </>
  );
}


